var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "folder-list-container select-folder-modal-content",
      class: { "is-dragging-files": _vm.isDraggingFiles },
      on: {
        dragover: function ($event) {
          $event.preventDefault()
          return _vm.onFilesDragOver.apply(null, arguments)
        },
        dragleave: _vm.onFilesDragLeave,
        drop: function ($event) {
          $event.preventDefault()
          return _vm.onBodyDrop.apply(null, arguments)
        },
      },
    },
    [
      _c("AllModals"),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "rename-folder-modal",
            title: "Rename Folder",
            centered: "",
          },
          on: {
            ok: _vm.renameFolder,
            cancel: _vm.cancelRenameFolder,
            hidden: _vm.cancelRenameFolder,
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function ({ ok, cancel }) {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-secondary" },
                      on: {
                        click: function ($event) {
                          return cancel()
                        },
                      },
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        disabled: !_vm.renamingFolderName.trim(),
                      },
                      on: {
                        click: function ($event) {
                          return ok()
                        },
                      },
                    },
                    [_vm._v("\n        Rename\n      ")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Folder name" } },
            [
              _c("b-form-input", {
                attrs: { placeholder: "Enter folder name" },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.renameFolder.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.renamingFolderName,
                  callback: function ($$v) {
                    _vm.renamingFolderName = $$v
                  },
                  expression: "renamingFolderName",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "select-folder-modal-preview",
            title: "Preview",
            size: "xl",
            centered: "",
            "body-class": "select-folder-preview__body",
            "hide-footer": "",
          },
        },
        [
          _vm.previewItem && _vm.isPreviewImage
            ? _c("img", {
                staticClass: "select-folder-preview__img",
                attrs: { src: _vm.previewItem.path, alt: "" },
              })
            : _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                _vm._v("\n      Preview not available\n    "),
              ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "folder-sticky-header" },
        [
          _c("SelectFolderModalToolbar", {
            attrs: {
              "show-create-folder": _vm.isFilesTab,
              "show-favorites": _vm.isFilesTab,
              "favorites-active": _vm.favoritesOnly,
            },
            on: {
              search: _vm.performSearch,
              clear: _vm.clearSearch,
              "create-folder": _vm.createFolder,
              "toggle-favorites": _vm.toggleFavorites,
            },
            scopedSlots: _vm._u([
              {
                key: "breadcrumb",
                fn: function () {
                  return [
                    _vm.isFilesTab
                      ? _c("FolderBreadcrumb", {
                          attrs: { breadcrumbs: _vm.breadcrumbs },
                          on: { goTo: _vm.goToFolder },
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.searchQuery,
              callback: function ($$v) {
                _vm.searchQuery = $$v
              },
              expression: "searchQuery",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.items.length || _vm.isListLoading || _vm.creatingFolder
        ? _c(
            "div",
            { staticClass: "folder-scroll-area" },
            [
              _vm.isListLoading || _vm.creatingFolder
                ? [
                    _c(
                      "div",
                      { staticClass: "folders-grid", style: _vm.gridVars },
                      _vm._l(_vm.pageSize, function (n) {
                        return _c(
                          "div",
                          {
                            key: n,
                            staticClass: "w-100 h-100",
                            staticStyle: { "min-height": "167px" },
                          },
                          [
                            _c("b-skeleton", {
                              attrs: { width: "100%", height: "88%" },
                            }),
                            _vm._v(" "),
                            _c("b-skeleton"),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]
                : [
                    _vm.isSearchActive &&
                    _vm.items.length &&
                    _vm.wasEnterPressed
                      ? _c(
                          "b-alert",
                          {
                            staticClass: "mb-3",
                            attrs: { show: "", variant: "info" },
                          },
                          [
                            _vm._v(
                              "\n        Found " +
                                _vm._s(_vm.totalCount) +
                                " result" +
                                _vm._s(_vm.totalCount > 1 ? "s" : "") +
                                ' for "' +
                                _vm._s(_vm.searchQuery) +
                                '"\n      '
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isSearchActive &&
                    !_vm.items.length &&
                    !_vm.isListLoading
                      ? _c(
                          "b-alert",
                          {
                            staticClass: "mb-3",
                            attrs: { show: "", variant: "warning" },
                          },
                          [
                            _vm._v(
                              '\n        No results found for "' +
                                _vm._s(_vm.searchQuery) +
                                '"\n      '
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.folderItems.length
                      ? _c("div", { staticClass: "section-container" }, [
                          _c(
                            "div",
                            {
                              staticClass: "folder-items folders-grid",
                              style: _vm.gridVars,
                            },
                            _vm._l(_vm.folderItems, function (item) {
                              return _c("GridItem", {
                                key: item.id,
                                attrs: {
                                  item: item,
                                  "is-selected": _vm.isSelected(item),
                                  "show-edit-button": _vm.canRenameFolder(item),
                                  "upload-on-drop": Boolean(item.id),
                                  draggable: Boolean(item.created_at),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onSelectedItem(item)
                                  },
                                  dblclick: function ($event) {
                                    return _vm.dblHandler(item)
                                  },
                                  edit: function ($event) {
                                    return _vm.startRenamingFolder(item)
                                  },
                                  dragstart: function ($event) {
                                    return _vm.onItemDragStart($event, item)
                                  },
                                  drop: function ($event) {
                                    return _vm.onFolderDrop($event, item)
                                  },
                                },
                              })
                            }),
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.otherItems.length
                      ? _c("div", { staticClass: "section-container" }, [
                          _c(
                            "div",
                            {
                              staticClass: "folders-grid",
                              style: _vm.gridVars,
                            },
                            _vm._l(_vm.otherItems, function (otherItem) {
                              return _c(
                                "div",
                                {
                                  key: otherItem.id,
                                  ref: `hoverWrap-${otherItem.id}`,
                                  refInFor: true,
                                  staticClass: "select-folder-hover-wrap",
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.onHoverEnter(otherItem)
                                    },
                                    mouseleave: function ($event) {
                                      _vm.hoveredId = null
                                    },
                                  },
                                },
                                [
                                  _c("GridItem", {
                                    attrs: {
                                      item: otherItem,
                                      "is-selected": _vm.isSelected(otherItem),
                                      "is-available-overlay":
                                        _vm.availableOverlay,
                                      draggable: "true",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onSelectedItem(otherItem)
                                      },
                                      dblclick: function ($event) {
                                        return _vm.fileDoubleClickHandler(
                                          otherItem
                                        )
                                      },
                                      dragstart: function ($event) {
                                        return _vm.onItemDragStart(
                                          $event,
                                          otherItem
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.hoveredId === otherItem.id
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "select-folder-hover-actions",
                                          style: _vm.getHoverActionsStyle(
                                            otherItem.id
                                          ),
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "select-folder-action-btn select-folder-action-btn--download",
                                              attrs: {
                                                type: "button",
                                                title: "Download",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  $event.preventDefault()
                                                  return _vm.downloadItem(
                                                    otherItem
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-download",
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.isPreviewableImage(otherItem)
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "select-folder-action-btn select-folder-action-btn--preview",
                                                  attrs: {
                                                    type: "button",
                                                    title: "Preview",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      $event.preventDefault()
                                                      return _vm.openPreview(
                                                        otherItem
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-search-plus",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ])
                      : _vm._e(),
                  ],
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "folder-scroll-area" },
            [
              _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                _vm._v("\n      Folder is empty\n    "),
              ]),
            ],
            1
          ),
      _vm._v(" "),
      _vm.isFilesTab
        ? _c(
            "div",
            { staticClass: "folder-drop-hint" },
            [
              _c("UploadIcon", { attrs: { width: 16, height: 16 } }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.dropHint))]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "folder-sticky-footer" }, [
        _vm.selectedItems.length
          ? _c("div", { staticClass: "selection-summary" }, [
              _c("span", { staticClass: "font-weight-bold" }, [
                _vm._v(
                  _vm._s(_vm.selectedItems.length) +
                    " item" +
                    _vm._s(_vm.selectedItems.length > 1 ? "s" : "") +
                    " selected"
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-center align-items-center item-pagination",
          },
          [
            _c("ItemPagination", {
              attrs: {
                value: _vm.currentPage,
                "per-page": _vm.pageSize,
                "total-rows": _vm.totalCount,
                disabled: _vm.isListLoading,
              },
              on: { change: _vm.onChangePage },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }